import React from "react";

function Sustainability(){
   return (
        <div className="h-screen flex">
                <section id="SideBar" className="fixed h-full">
                        <div className="">

                        </div>
                </section>
                <section className="flex-grow">
                        <div className="">

                        </div>
                </section>
        </div>
   )
}
export default Sustainability